<template>
  <div>
    <modal-base 
      :visible="visible"
      @input="$emit('update:visible', $event)"
      :title="dialogContent.title"
      :confirm-text="dialogContent.continue"
      :cancel-text="dialogContent.cancel"
      :centered="true"
      @confirm="$emit('confirm')"
      @cancel="$emit('cancel')">
      <div class="text-left mb-3 px-4">
        <p v-html="dialogContent.message"></p>
      </div>
    </modal-base>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import ModalBase from '@/components/ModalBase.vue';
import { VirusCheckStatus } from '@/types/enums/virusCheckStatus';
import { ModalDialogWording } from '@/types/data/modalDialogWording';
import languageService from '@/services/languageService';

@Component({
  components: {
    ModalBase
  }
})
export default class DownloadVirusWarningWindow extends Vue {
  @Prop({ type: Boolean, default: false }) readonly visible!: boolean;
  @Prop({ type: String, default: '' }) readonly virusCheckStatus!: string;

  get dialogContent(): ModalDialogWording {
    return this.getModalDialogWording(this.virusCheckStatus);
  }

  private getModalDialogWording(virusCheckStatus: string): ModalDialogWording {
    switch (virusCheckStatus) {
      case VirusCheckStatus.ThreatDetected:
        return {
          title: languageService.t('virus-check-modal.detected.title'),
          message: languageService.t('virus-check-modal.detected.message'),
          cancel: languageService.t('virus-check-modal.cancel-button'),
          continue: languageService.t('virus-check-modal.continue-button'),
        };
      case VirusCheckStatus.CheckFailed:
      case VirusCheckStatus.FileTooLarge:
      case VirusCheckStatus.TimeOut:
      case VirusCheckStatus.Skipped:
      case VirusCheckStatus.VirusCheckUnavailable:
      default:
        return {
          title: languageService.t('virus-check-modal.not-completed.title'),
          message: languageService.t('virus-check-modal.not-completed.message'),
          cancel: languageService.t('virus-check-modal.cancel-button'),
          continue: languageService.t('virus-check-modal.continue-button'),
        };
    }
  }
}
</script>